/**
 * The graphs that speak the Agent's screen: no board, cards under the answer,
 * chips in the A2UI footer, the questionnaire card, the route pane and the
 * visitor's position. Guide v2 joined on 18.10.2026 — it builds the same cards
 * in code (`graphs/peterhof_v2/screen.py`), so the client draws both alike.
 * A module of its own, with no imports: the location modules read it, and
 * `sessionStore` imports them.
 */
export function isAgentFamily(assistantId: string): boolean {
  return assistantId === 'peterhof_agent' || assistantId === 'peterhof_v2';
}

/**
 * Does this graph rebuild a saved plan from `context.trip_link` (INV-PH-166, `peterhof_v2.return_link`)? Guide v2
 * alone: the Agent has no token on its cards, and an unknown context key can move a graph onto another `Context`.
 */
export function readsTripLink(assistantId: string): boolean {
  return assistantId === 'peterhof_v2';
}
